import React from 'react';
import './SideVolume.scss';

const SideVolume = ({ volumeNumber, childAsRenderedProps }) => {
    return (
        <div className='side-volume-container'>
            <div className='side-volume-side'>
                <span className='side-volume-side-text'>Vol.</span>
                <span className='side-volume-side-number'>{volumeNumber}</span>
            </div>


            <div className='side-volume-children-wrapper'>
                {childAsRenderedProps}
            </div>
        </div>
    );
};

export default SideVolume;